<template>
  <div
    class="flex justify-start _no_drag ml-[140px] cursor-pointer absolute left-1/2 top-[14px]"
  >
    <button class="m-auto" @click="printInfo">打印信息</button>
  </div>
</template>
<script lang="ts" setup>
// import { useImagesStore } from '@/store/use-images-store';
// import { TemplateService } from '@/services/template.service';
import {
  useImageRiveBufferCache,
  useShapeCount,
  useWatchfaceAodPixel,
  useWatchfaceManage,
  useWatchfaceSave
} from '@/hooks';
import { useRotatedImages } from '@/hooks/use-rotated-images';
import { useEditorStore } from '@/store/use-editor-store';
// import { useImagesStore } from '@/store/use-images-store';
import { useRouter } from 'vue-router';
const editorStore = useEditorStore();
const { cacheWholeRiveImages } = useImageRiveBufferCache();
const router = useRouter();
const { validShapeCount } = useShapeCount();
const printInfo = async () => {
  console.clear();
  await cacheWholeRiveImages();
};
</script>
